export default {
  position: 0,
  linkId: undefined,
}
